import ConfigList from 'Model/ConfigList'
import { branch } from 'Model/constants'

class NameKeys extends ConfigList
  @className = 'NameKeys'

  constructor: ->
    super('nameKeys')

  @load: ->
    super('nameKeys', @)

export default NameKeys
